import script from "./HrCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HrCard.vue?vue&type=script&setup=true&lang=js"

import "./HrCard.vue?vue&type=style&index=0&id=fc195c56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc195c56"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard});qInstall(script, 'directives', {Ripple});
